import React from 'react';
import { processSteps } from '../../content/siteData';

function ProcessPage() {
  return (
    <main className="gop-page">
      <section className="gop-page-hero">
        <div className="gop-container">
          <span className="gop-eyebrow">Process</span>
          <h1>A step-by-step process that keeps things manageable.</h1>
          <p>
            Better outcomes often come from better sequencing. Our process helps reduce confusion
            and keeps every stage easier to track.
          </p>
        </div>
      </section>

      <section className="gop-page-section">
        <div className="gop-container gop-timeline">
          {processSteps.map((item) => (
            <article key={item.step} className="gop-timeline-card">
              <span>{item.step}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}

export default ProcessPage;
